import React from 'react'
import ErrorBoundary from '../../../components/ErrorBoundary'
import CategoriesPage from "../../../components/settings/categories/CategoriesPage"

const CategoriesPageWithBoundary = (props) => (
    <ErrorBoundary
        componentName="CategoriesPage"
        showReload
        logToBackend
        title="Erro em Categorias"
        message="Ocorreu um erro ao carregar as categorias. Tente recarregar."
    >
        <CategoriesPage {...props} />
    </ErrorBoundary>
)

export default CategoriesPageWithBoundary
